import {z} from 'zod';

import {isNil} from 'ramda';

import {i18n} from '@dms/i18n';

import {
  accountingCorrectiveTaxDocumentInvoiceItem,
  accountingDocumentFormValuesSchema,
} from '../types';

export const createCorrectiveTaxDocumentSchema = accountingDocumentFormValuesSchema
  .extend({
    documentSeriesId: z.string(),
    issueDate: z.string(),
    dueDate: z.string(),
    dateOfTaxableSupply: z.string(),
    dateOfReception: z.string(),
    reason: z.string(),
    invoiceItems: z.array(accountingCorrectiveTaxDocumentInvoiceItem),
  })
  .superRefine((data, ctx) => {
    if (
      data.paymentInfo.paymentMethod === 'BANK_TRANSFER' &&
      (!data.paymentInfo.bankAccount || data.paymentInfo.bankAccount.trim() === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['paymentInfo', 'bankAccount'],
      });
    }
    if (
      data.isExchangeRateRatioEnabled &&
      (isNil(data.exchangeRateRatio?.ratio) || data.exchangeRateRatio?.ratio.trim() === '')
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['exchangeRateRatio', 'ratio'],
      });
    }
  });
